import { FALLBACK_BANDS } from './inputSanityModel'

export type SliderTrack = {
  min: number
  max: number
  step: number
}

export const OWNER_SALARY_SLIDER_MAX = 300000

export const SLIDER_TRACKS = {
  profitMargin: { min: 10, max: 35, step: 1 },
  crewHoursPerWeek: { min: 10, max: 60, step: 1 },
  crewDaysPerWeek: { min: 1, max: 7, step: 1 },
  ownerHoursPerWeek: { min: 20, max: 60, step: 1 },
  ownerSalary: { min: FALLBACK_BANDS.ownerSalary.low, max: OWNER_SALARY_SLIDER_MAX, step: 5000 },
  workerPayHourly: { min: 10, max: 60, step: 0.5 },
  workerPaySalary: { min: 30000, max: 200000, step: 2500 }
} as const satisfies Record<string, SliderTrack>

export const fitsTrack = (value: number | null | undefined, track: SliderTrack): boolean => {
  if (value === null || value === undefined || !isFinite(value)) {
    return false
  }
  return value >= track.min && value <= track.max
}

export const clampToTrack = (value: number | null | undefined, track: SliderTrack): number => {
  if (value === null || value === undefined || !isFinite(value)) {
    return track.min
  }
  return Math.min(track.max, Math.max(track.min, value))
}

export const opensInTypedBox = (
  value: number | null | undefined,
  track: SliderTrack,
  allowCustom: boolean
): boolean => {
  if (!allowCustom) {
    return false
  }
  return !fitsTrack(value, track)
}
